import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e61613f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-preview" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Save as SVG ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Save as PNG ")

import { ref } from 'vue';
import QrcodeVue from 'qrcode.vue';
import Navbar from '@/components/ui/Navbar.vue';
import Page from '@/components/ui/Page.vue';
import Container from '@/components/ui/Container.vue';
import Copyrights from '@/components/Copyrights.vue';
import Button from '@/components/ui/Button.vue';
import Input from '@/components/ui/Input.vue';
import Select from '@/components/ui/Select.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const LEVELS = [
  {
    value: 'L',
    label: 'Size - L',
  },
  {
    value: 'M',
    label: 'Size - M',
  },
  {
    value: 'Q',
    label: 'Size - Q',
  },
  {
    value: 'H',
    label: 'Size - H',
  },
] as const;
const BACKGROUND = '#ffffff';
const FOREGROUND = '#000000';

const level = ref<typeof LEVELS[number]['value']>('L');
const size = ref(400);
const text = ref('');

const downloadSVG = (e: Event) => {
  const svg = document.querySelector('.qr-preview svg');
  const anchor = document.querySelector('#download-svg') as HTMLAnchorElement;
  if (!svg || !anchor) {
    e.preventDefault();
    return;
  }

  const svg2000 = /^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/;
  const svg1999 = /^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/1999\/xlink"/;

  //get svg source.
  let source = new XMLSerializer().serializeToString(svg);

  //add name spaces.
  if (!svg2000.exec(source)) {
    source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
  }
  if (!svg1999.exec(source)) {
    source = source.replace(
      /^<svg/,
      '<svg xmlns:xlink="http://www.w3.org/1999/xlink"'
    );
  }

  //add xml declaration
  source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
  //convert svg source to URI data scheme.
  const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source);

  anchor.href = url;
};

const downloadPNG = (e: Event) => {
  const canvas = document.querySelector(
    '.qr-preview canvas'
  ) as HTMLCanvasElement;
  const anchor = document.querySelector('#download-png') as HTMLAnchorElement;
  if (!canvas || !anchor) {
    e.preventDefault();
    return;
  }

  let data = canvas.toDataURL('image/png');
  /* Change MIME type to trick the browser to downlaod the file instead of displaying it */
  data = data.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');

  /* In addition to <a>'s "download" attribute, you can define HTTP-style headers */
  data = data.replace(
    /^data:application\/octet-stream/,
    'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=qr.png'
  );

  anchor.href = data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, { class: "page" }, {
    default: _withCtx(() => [
      _createVNode(Container, { class: "page-content" }, {
        default: _withCtx(() => [
          _createVNode(Copyrights),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(QrcodeVue, {
              value: text.value,
              size: size.value,
              level: level.value,
              background: BACKGROUND,
              foreground: FOREGROUND,
              "render-as": "canvas"
            }, null, 8, ["value", "size", "level"]),
            _createVNode(QrcodeVue, {
              value: text.value,
              size: size.value,
              level: level.value,
              background: BACKGROUND,
              foreground: FOREGROUND,
              "render-as": "svg"
            }, null, 8, ["value", "size", "level"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Select, {
              class: "input",
              value: level.value,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (level.value = $event.target.value as typeof LEVELS[number]['value'])),
              options: _unref(LEVELS),
              label: "Level"
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Input, {
              class: "input",
              value: text.value,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (text.value = $event.target.value)),
              placeholder: "Type your text"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Button, {
              id: "download-svg",
              href: "/qr.svg",
              download: "qr.svg",
              onClick: downloadSVG
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(Button, {
              id: "download-png",
              href: "/qr.png",
              download: "qr.png",
              onClick: downloadPNG
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(Navbar)
    ]),
    _: 1
  }))
}
}

})